import React from "react";
import { Div, Text } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

class InfluencersPhone extends React.Component {
  render() {
    const { title, features, image, footerTitle } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer p={{ x: { xs: "0", md: "2.5rem" } }}>
          <Div className="influencer-phone" p={{ y: "2rem" }} pos="relative">
            <Div bg="#9297A3" p={{ lg: "2.5rem" }}>
              <Div
                w={{ lg: "29.4rem", md: "30rem", xs: "100%" }}
                //d={{ xs: "flex", md: "block" }}
                pos={{ md: "absolute", xs: "inherit" }}
                right={{ lg: "-1rem", md: "-4.375rem" }}
                top={{ lg: "50%", md: "2%" }}
                p={{ t: { lg: "0", xs: "1.5rem" } }}
                transform={{ lg: "translate(-2rem, -49%)" }}
              >
                <ImageLink
                  link={image.description}
                >
                  <Div
                    // p={{ b: { lg: "45rem", md: "40rem", xs: "33rem" } }}
                    //w={{ lg: "35rem", md: "35rem", xs: "100%" }}
                    p={{ b: { xs: "140%", md: "128%", lg: "157%" } }}
                    bgImg={image.file.url}
                    bgSize="cover"
                    bgRepeat="no-repeat"
                  ></Div>
                </ImageLink>
              </Div>
              <Div
                textAlign={{ lg: "left", md: "left", xs: "center" }}
                p={{ xs: "1.5rem", md: "1.5rem", lg: "0" }}
              >
                <Div m={{ b: "2.5rem" }}>
                  <Text
                    textSize={{ xs: "caption4", md: "display2" }}
                    textWeight="700"
                    className="phone-heading"
                    //p={{ r: { lg: "50%", md: "50%" } }}
                    maxW={{ md: "22rem", lg: "28.25rem" }}
                    tag="h2"
                  >
                    {title}
                  </Text>
                </Div>
                <Div
                  p={{
                    r: { lg: "40%", md: "40%" },
                    b: { lg: "1.5rem", xs: "2rem" },
                  }}
                >
                  <Text
                    textSize="subheader6"
                    textWeight="700"
                    textAlign="left"
                    style={{ lineHeight: "40px" }}
                    dangerouslySetInnerHTML={{
                      __html: features.replace(/(?:\r\n|\r|\n)/g, "<br>"),
                    }}
                  ></Text>
                </Div>
              </Div>
            </Div>
            <Div bg="#A6AEC0" p={{ lg: "2.5rem", md: "1.5rem", xs: "2rem" }}>
              <Text
                textAlign={{ lg: "left", md: "left", xs: "center" }}
                p={{ x: { lg: "0", md: "0", xs: "1.5rem" }, r: { md: "50%" } }}
              >
                {footerTitle}
              </Text>
              <Div
                m={{ t: "2rem" }}
                p={{ r: { lg: "50%", md: "50%" } }}
                d="flex"
                justify="space-between"
                align="center"
              >
                <Div d="inline-flex" flexDir="column" align="center">
                  <ImageLink link="">
                    <Div
                      h="5.5rem"
                      w="3.8rem"
                      bgImg="/images/Silver.png"
                      bgSize="contain"
                      bgRepeat="no-repeat"
                    ></Div>
                  </ImageLink>
                  <span>Silver</span>
                </Div>
                <Div w="20%" border="2px solid" borderColor="white"></Div>
                <Div d="inline-flex" flexDir="column" align="center">
                  <ImageLink link="">
                    <Div
                      h="5.5rem"
                      w="3.8rem"
                      bgImg="/images/Gold.png"
                      bgSize="contain"
                      bgRepeat="no-repeat"
                    ></Div>
                  </ImageLink>
                  <span>Gold</span>
                </Div>
                <Div w="20%" border="2px solid" borderColor="white"></Div>
                <Div d="inline-flex" flexDir="column" align="center">
                  <ImageLink link="">
                    <Div
                      p={{ b: "4.5rem" }}
                      m={{ t: "1rem" }}
                      w="3.8rem"
                      bgImg="/images/Diamond.png"
                      bgSize="contain"
                      bgRepeat="no-repeat"
                    ></Div>
                  </ImageLink>
                  <span>Diamond</span>
                </Div>
              </Div>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}

export default InfluencersPhone;
